import * as React from "react";
import { Button, Grid, useDisclosure } from "@chakra-ui/react";
import { IoBook } from "react-icons/io5";
import { Modal } from "components";
import { Description, Other } from "./components";
import {
  CALCULUS,
  ENAMEL,
  FRACTURE,
  FURCATION,
  GINGIVITIS,
  MOBILITY,
  PERIODONTAL,
  RESORPTION
} from "./duck";

const Legend: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button leftIcon={<IoBook />} colorScheme="minor" onClick={onOpen}>
        Legend
      </Button>
      {isOpen && (
        <Modal isOpen title="Legend" onClose={onClose} size="5xl">
          <Grid gridTemplateColumns="repeat(3, 1fr)" gridGap="24px">
            <Description label="Periodontal" options={PERIODONTAL} />
            <Description label="Furcation" options={FURCATION} />
            <Description label="Mobility" options={MOBILITY} />

            <Description label="Gingivitis" options={GINGIVITIS} />
            <Description label="Calculus" options={CALCULUS} />
            <Description label="Enamel" options={ENAMEL} />

            <Description label="Fracture" options={FRACTURE} />
            <Description label="Resorption" options={RESORPTION} />
          </Grid>
          <Other />
        </Modal>
      )}
    </>
  );
};

export default Legend;
